// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tooltip[data-v-3b9c14a8]{position:relative}.tooltip-open[data-v-3b9c14a8]{z-index:2}.tooltip-overlay[data-v-3b9c14a8]{width:100vw;height:100vh;position:fixed;top:0;left:0;z-index:1}@media screen and (min-width: 1000px){.tooltip-overlay[data-v-3b9c14a8]{display:none}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
